import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { ApiMaintenanceService } from '../maintenance.service';

export const apiNoMaintenanceGuard = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const apiMaintenanceSrv = inject(ApiMaintenanceService);
  apiMaintenanceSrv.run();
  return apiMaintenanceSrv.updates.pipe(
    map(() => {
      console.log('result');
      if (apiMaintenanceSrv.enabled && apiMaintenanceSrv.enabledStrict) {
        router.navigate(['/maintenance']);
        return false;
      } else {
        return true;
      }
    }),
  );
};
